import { render } from "./Empresas.vue?vue&type=template&id=646d47a8&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"

import "./Empresas.vue?vue&type=style&index=0&id=646d47a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-646d47a8"

export default script